export default __webpack_public_path__ + "static/media/Bb4.0cd53f6a.mp3";